import dayjs from 'dayjs'

import localeSl from 'dayjs/locale/sl'
import customParseFormat from 'dayjs/plugin/customParseFormat'

import { nullDate } from '@/libs/helpers'

dayjs.extend(customParseFormat)

dayjs.locale(localeSl)

export const formatDate = (date: Date | number | string, showTime = false) => {
    const formatToken = showTime ? 'DD.MM.YYYY, HH:mm' : 'DD.MM.YYYY'
    return dayjs(date).format(formatToken)
}

export const isDateNull = (date: Date | number | string | undefined) => {
    if (!date) return true
    return dayjs(date).format('YYYY-MM-DD') === nullDate
}

export default dayjs
